import script from "./MobileBettingSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./MobileBettingSection.vue?vue&type=script&setup=true&lang=ts"

import "./MobileBettingSection.vue?vue&type=style&index=0&id=256b924e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-256b924e"]])

export default __exports__